// extracted by mini-css-extract-plugin
export default {"text":"hutchens2021_text__+o43l","main":"hutchens2021_main__jZdX-","background":"hutchens2021_background__NKtKJ"};